import { ActionTree } from 'vuex';
import { AxiosResponse } from 'axios';

import HttpService from '@/plugins/http-service';
import IRootState from '@/store/types/IRootState';

import IFleetState from './types/IFleetState';
import IFleetMeta from './types/IFleetMeta';
import IFleetHeader from './types/IFleetHeader';
import IFleet from './types/IFleet';

const actions: ActionTree<IFleetState, IRootState> = {
  async load(context) {
    try {
      const { data: {
        meta,
        header,
        fleet,
      } }: AxiosResponse<{
        meta: IFleetMeta,
        header: IFleetHeader,
        fleet: IFleet[],
      }> = await HttpService.get('page/fleet.json');

      context.commit('setMeta', meta);
      context.commit('setHeader', header);
      context.commit('setFleet', fleet);

      return { meta, header, fleet };
    } catch (error) {
      return Promise.reject(error);
    }
  },
};

export default actions;
